//* Alphabetical sorting
const sortAlphabeticalByName = (lastOne, nextOne) => {
  const aLast = lastOne?.name?.charAt(0);
  const bLast = nextOne?.name?.charAt(0);
  return aLast > bLast ? 1 : -1;
};

//* reusable filter functions
const filterTrackingSystems = (item) => {
  const key = item.key.split('.')[0];
  // return key === 'tracking_hardware';
  return key === 'tracking_hardware' && item.authorized; //* limit to return only authorized
};

// const filterCourses = (item) => {
//   const key = item.key.split('.')[0];
//   // if (key === 'course' && item.key.split('.')[1] === 'bc0687ee-415e-f8df-13a6-f185f53a110f') {
//   //   item.game = 'apex';
//   // } else {
//   //   item.game = 'connect';
//   // }
//   return key === 'course' && item.authorized; //* limit to return only authorized
// };

const filterPermissions = (item) => {
  const key = item.key.split('.')[0];
  return key !== 'course' && key !== 'tracking_hardware' && item.authorized; //* limit to return only authorized
};

//* Group permissions into categories
const groupPermissions = (licenseDetails) => {
  try {
    const trackingSystems =
      licenseDetails?.permissions?.filter(filterTrackingSystems)?.sort((lastOne, nextOne) => {
        return sortAlphabeticalByName(lastOne, nextOne);
      }) ?? [];

    // const courses =
    //   licenseDetails?.permissions?.filter(filterCourses)?.sort((lastOne, nextOne) => {
    //     return sortAlphabeticalByName(lastOne, nextOne);
    //   }) ?? [];

    const { courses, apexCourses, connectCourses } = licenseDetails?.permissions?.reduce(
      (acc, perm) => {
        if (perm.key.startsWith('course.') && perm.authorized) {
          if (perm?.game === 'apex') {
            acc.apexCourses.push(perm);
          } else if (perm?.game === 'connect') {
            acc.connectCourses.push(perm);
          } else {
            acc.connectCourses.push(perm);
          }
          acc.courses.push(perm);
        }
        return acc;
      },
      { courses: [], apexCourses: [], connectCourses: [] }
    );

    const permissions =
      licenseDetails?.permissions?.filter(filterPermissions)?.sort((lastOne, nextOne) => {
        return sortAlphabeticalByName(lastOne, nextOne);
      }) ?? [];

    // const oldCourses =
    //   licenseDetails?.permissions_old?.filter(filterCourses)?.sort((lastOne, nextOne) => {
    //     return sortAlphabeticalByName(lastOne, nextOne);
    //   }) ?? [];
    // const oldTrackingSystems =
    //   licenseDetails?.permissions_old?.filter(filterTrackingSystems)?.sort((lastOne, nextOne) => {
    //     return sortAlphabeticalByName(lastOne, nextOne);
    //   }) ?? [];
    // const oldPermissions =
    //   licenseDetails?.permissions_old?.filter(filterPermissions)?.sort((lastOne, nextOne) => {
    //     return sortAlphabeticalByName(lastOne, nextOne);
    //   }) ?? [];

    return {
      trackingSystems,
      courses:
        courses?.sort((lastOne, nextOne) => {
          return sortAlphabeticalByName(lastOne, nextOne);
        }) ?? [],
      apexCourses:
        apexCourses?.sort((lastOne, nextOne) => {
          return sortAlphabeticalByName(lastOne, nextOne);
        }) ?? [],
      connectCourses:
        connectCourses?.sort((lastOne, nextOne) => {
          return sortAlphabeticalByName(lastOne, nextOne);
        }) ?? [],
      permissions,
      // oldTrackingSystems,
      // oldCourses,
      // oldPermissions,
    };
  } catch (error) {
    console.error('ERROR', error);
    throw new Error('Error grouping permissions');
  }
};

export {
  sortAlphabeticalByName,
  filterTrackingSystems,
  // filterCourses,
  filterPermissions,
  groupPermissions,
};
